<template>
	<div>
		<div class="photo-container">
			<div class='spec-name'>
			  <span>{{chosenOrder.spec_name}}</span>
			</div>
			<div style="width: 100vw;" v-if="Array.isArray(chosenOrder.final_pic_name)">
				<swiper :options="swiperOption" ref="mySwiper">
					<swiper-slide v-for="(item, index) in chosenOrder.final_pic_name" :key="index">
						<div class='image-dig'>
							<img class='preview' :src="`${getPhotoBaseUrl}${item}`"  />
						</div>
					</swiper-slide>
					<div class="swiper-pagination" slot="pagination"></div>
				</swiper>
				<!-- <div class='self-pagination'>{{swiper.realIndex+1}}/{{chosenOrder.final_pic_name.length}}</div> -->
			</div>
			<div class='image-dig' v-else>
				<img :src="`${getPhotoBaseUrl}${chosenOrder.final_pic_name}`" class='preview' />
			</div>
			<div>长按图片保存至手机相册（仅限安卓用户）</div>
		</div>
		<div @click="openSave" class='waste'>
			<div class='save-container'>
				<div class='save-title'>
					保存电子照
				</div>
				<div class='save-ways-container'>
					<div class='save-way' v-if='chosenOrder.extract_code'>
					<img src="../assets/extractedCode.png" class="save-way-icon" />
					<div class="save-way-text">提取码</div>
					</div>
					<div class='save-way' >
					<img src="../assets/email.png" class="save-way-icon" />
					<div class="save-way-text">发送到邮箱</div>
					</div>
				</div>
				
			</div>
		</div>
		<mt-popup 
		v-model="saveVisible" 
		position="bottom">
			 <div class='save-container'>
				<div class='save-title'>
					保存电子照
					<div class='close-save' @click="closeSave">×</div>
				</div>
				<div class='save-ways-container'>
					<div class='save-way' @click="chooseSaveWay('extractedCode')" v-if='chosenOrder.extract_code'>
					<img src="../assets/extractedCode.png" class="save-way-icon" />
					<div class="save-way-text" :class='chosenWay=="extractedCode"?"chosen-save-way-text":""'>提取码</div>
					</div>
					<div class='save-way' @click="chooseSaveWay('email')">
					<img src="../assets/email.png" class="save-way-icon" />
					<div class="save-way-text" :class='chosenWay=="email"?"chosen-save-way-text":""'>发送到邮箱</div>
					</div>
				</div>
				<div v-show="chosenWay=='extractedCode'">
					<div class='save-tip'>
						请在“电脑浏览器”中打开网址提取证件照
					</div>
					<div class='cell'>
						<div class='cell-title'>下载地址</div>
						<div class='cell-content'>
							www.id-photo-verify.com/t
						</div>
					</div>
					<div class='cell'>
						<div class='cell-title'>提取码</div>
						<div class='cell-content'>
							{{chosenOrder.extract_code}}
						</div>
					</div>
					<div class='execute-container'>
						<div class='save-execute copy' @click="copyExtractedCode" :data-clipboard-text="`下载地址:www.id-photo-verify.com/t
提取码: ${chosenOrder.extract_code}`">复制地址及提取码</div>
					</div>
				</div>
				<div v-show="chosenWay=='email'">
					<div class='save-tip'>
						请在以下输入框中输入您的邮箱，每单最多可以发送3次
					</div>
					<div class='cell'>
						<div class='cell-title'>电子邮箱</div>
						<div class='cell-content' @click="enterEmail">
						{{Email?Email:"请输入您的电子邮箱"}}
						</div>
					</div>
					<div class='execute-container'>
						<div class='save-execute' @click="sendEmail">发送至指定邮箱</div>
					</div>
				</div>
			</div>
		</mt-popup>
	</div>
</template>

<script>
import {sendEMailEle } from "@/data/api";
import { config } from "@/config/config";
import Clipboard from 'clipboard';
// import VueAwesomeSwiper from 'vue-awesome-swiper';
// import 'swiper/dist/css/swiper.css'

export default {
	data(){
		return {
			chosenOrder:{},
			chosenWay:'extractedCode',
			Email:'',
			saveVisible:false,
			swiperOption:{
				notNextTick:true,
				loop : true,
				effect : 'coverflow',
				slidesPerView:2,
				centeredSlides: true,
				coverflowEffect: {
					rotate: 0,
					stretch: -20,
					depth: 60,
					modifier: 2,
					slideShadows : false
				},
				autoplay: {
					delay: 3000,
					stopOnLastSlide: false,
					disableOnInteraction: true,
				},
				pagination: {
					el: '.swiper-pagination',
					type: 'fraction',
					modifierClass  : 'self-pagination-',
				},
			}
		};
	},
	created: function() {
		this.getPhotoBaseUrl = config.getPhotoBaseUrl;
		console.log(this.$route.query);
		this.chosenOrder=this.$route.query.orderInfo;
		this.$ba.trackPageview('savePhoto');
	},
	mounted(){
		var copybtn = document.getElementsByClassName('copy')
		this.clipboard = new Clipboard(copybtn);
	},
	computed: {
		swiper() {
			return this.$refs.mySwiper.swiper
		}
	},
	methods:{
		openSave(e){
			this.saveVisible=true;
			if(!this.chosenOrder.extract_code){
				this.chosenWay='email'
			}
		},
		closeSave(){
			this.saveVisible=false;
		},
		chooseSaveWay(e){
			this.chosenWay=e
		},
		enterEmail(){
				let Email=prompt("请输入您的邮箱");
				if(Email){
					this.Email=Email;
				}
		},
		sendEmail(){
			let openId_tmp = this.openId || localStorage.openId;
				let re = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/;
				if (re.test(this.Email)) {
					sendEMailEle(this.Email,this.chosenOrder.go_print.order_id,openId_tmp).then(( res ) => {
						console.log(res)
						if(res.data.code==200){
							ap.showToast({
								content: `发送成功!剩余发送次数${res.data.remaining_time}`
							});
						}else if(res.data.code==400){
							ap.showToast({
								content: res.data.mes
							});
						}else{
							ap.showToast({
								content: "发送失败，订单未支付或已过期！"
							})
						}
					})
					.catch(err => {
					  console.log(err)
					})
					
				}else{
					ap.showToast({
						content: '请输入有效的邮箱地址！'
					});
				}
		},
		copyExtractedCode(){
			this.clipboard.on('success', function (e) {
				console.log(e);
				alert("复制成功！")
			})
			this.clipboard.on('error', function (e) {
				console.log(e);
				alert("复制失败！请尝试长按文字复制！")
			});
		},
	},
	
}
</script>

<style scoped>
	body{
		background-color: #ffffff;
	}
	.spec-name{
	  font-weight:bold;
	  color:rgba(51,51,51,1);
	  font-size:17px;
	  margin-bottom: 10px;
	}
	.image-dig{
	  padding:6px;
	  width: 53.333vw;
	  height: auto;
	  background-color: white;
	}
	.photo-container{
		padding-top: 46px;
		display: flex;
		flex-direction: column;
		text-align: center;
		align-items: center;
	}
	.preview {
	  width: 100%;
	  height: 100%;
	  vertical-align: middle;
	}
	.waste{
		position: fixed;
		bottom: 0;
	}
	.save-container{
	  height: auto;
	  background: #ffffff;
		width: 100vw;
	}
	.save-title{
	  font-size:12px;
	  color:rgba(102,102,102,1);
	  height: 49px;
	  padding-top: 20px;
	  padding-bottom: 12px;
	  text-align: center;
	  position: relative;
	}
	.close-save{
	  position: absolute;
	  height: 0.32rem;
	  line-height: 0.32rem;
	  color: rgba(191,191,191,1);
	  font-size: 32px;
	  top: 10px;
	  right: 10px;
	}
	.save-ways-container{
	  width: 100%;
	  height: 100px;
	  display: flex;
	}
	.save-way{
	  height: 100px;
	  width: 33.33vw;
	  margin: auto;
	  display: inline-flex;
	  flex-direction: column;
	  justify-content: center;
	  align-items: center;
	}
	.save-way-icon{
	  width: 50px;
	  height: 50px;
	}
	.save-way-text{
	  margin-top: 5px;
	  font-size:12px;
	  color:rgba(153,153,153,1); 
	}
	.chosen-save-way-text{
	  color:rgba(245,166,35,1);
	}
	.save-tip{
	  text-align: center;
	  width: 100%;
	  height: 40px;
	  line-height: 40px;
	  font-size:13px;
	  color:rgba(245,166,35,1);
	  margin-top: 10px;
	  margin-bottom: 6px;
	  background:rgba(255,249,240,1);
	}
	.execute-container{
	  width: 100vw;
	  height: 60px;
	  margin-top: 15px;
	  background:rgba(255,255,255,1);
	  box-shadow:0px 0px 16px 0px rgba(211,211,211,0.5);
	  padding:10px 8px;
	}
	.save-execute{
	  width:94.667vw;
	  height:45px;
	  background:rgba(68,128,231,1);
	  box-shadow:0px 5px 10px 0px rgba(68,128,231,0.25);
	  border-radius:22.5px;
	  line-height:45px;
	  color: white;
	  font-size: 16px;
	  text-align: center;
	}
	.placeholder{
	  color: #999999;
	  font-size: 13px;
	  text-align: right;
	}
	.self-pagination-fraction{
		position: static;
		font-size:12px;
		color:rgba(153,153,153,1);
	}
</style>
